import React from 'react'
import { Panel } from 'primereact/panel'

import './CustomPanel.css'
import Btn from '../Btn/Btn'
import TextBtn from '../TextBtn/TextBtn'

export default function CustomPanel({
  children,
  onNovo,
  onVoltar,
  showBtnNovo = true,
  btnLabel = 'Novo',
  childrenButtons = null,
}) {
  const novoBtn = (
    <Btn minWidth={null} onClick={onNovo}>
      {btnLabel}
    </Btn>
  )
  const voltarBtn = <TextBtn onClick={onVoltar}>Voltar</TextBtn>
  const customHeader = (
    <div className="p-grid">
      <div className="p-col-3">
        {showBtnNovo ? novoBtn : null}
        <div style={{ display: 'inline-block', marginLeft: 10 }}>{voltarBtn}</div>
      </div>
      {childrenButtons}
    </div>
  )
  return (
    <div className="CustomPanel">
      <Panel header={customHeader}>{children}</Panel>
    </div>
  )
}
